import { GqlSettingsFormTemplateQuestionCondition } from "~/__generated__";

import { FormTemplateQuestionFormInputs } from "../components/FormTemplateQuestionForm";

export default function buildConditionObject(
    condition: GqlSettingsFormTemplateQuestionCondition,
    formData: FormTemplateQuestionFormInputs,
    existingId?: string,
) {
    const id = existingId ?? crypto.randomUUID();
    switch (condition.__typename) {
        case "GqlSettingsFormTemplateQuestionConditionNone":
            return {
                id,
                type: "_" as const,
            };
        case "GqlSettingsFormTemplateQuestionConditionIsEqual":
            return {
                id,
                type: "==" as const,
                fieldKey: formData.conditionSelectedQuestion,
                value: formData.conditionSelectedQuestionOption,
            };
        case "GqlSettingsFormTemplateQuestionConditionOr":
            return {
                id,
                type: "||" as const,
                conditions: formData.conditionOrConditions?.map(condition => ({
                    id: condition.id ?? crypto.randomUUID(),
                    type: "==" as const,
                    fieldKey: condition.conditionSelectedQuestion,
                    value: condition.conditionSelectedQuestionOption,
                })),
            };
    }
}
